import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetNews, actionDeleteNovelty } from "../actions/NoveltyActions"
import { LOGIN_ROUTE, NEWS_ADD_ROUTE, NEWS_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Util, { ERROR } from '../common/Util'


class News extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, news:[], filter:"", noveltyForDelete:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteNoveltySuccess=this.getDeleteNoveltySuccess.bind(this)
    this.onConfirmDeleteNovelty=this.onConfirmDeleteNovelty.bind(this)
    this.onAddNovelty=this.onAddNovelty.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }

  componentWillMount(){
    if (this.props.login) {
      // console.log("COMPONENT WILL MOUNT")
      this.props.actionGetNews(this.onChangePage, this.getNewsError)
    }
  }

  getNewsError(e){
    console.log("ERROR NEWS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las novedades.")
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let news = this.props.noveltyList.filter((e)=>{return e.nvtTitle.match(filter)})
    let count = news.length
    news = news.slice(from, end)
    this.setState({page:newPage, count:count, news:news})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let news = this.props.noveltyList.filter((e)=>{return e.nvtTitle.match(filter)})
    let count = news.length
    news = news.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, news:news})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }

  onAddNovelty(){
    this.props.history.push(NEWS_ADD_ROUTE)
  }

  onEditNovelty(novelty){
    this.props.history.push(NEWS_EDIT_ROUTE, novelty)
  }

  onConfirmDeleteNovelty(){
    this.props.actionDeleteNovelty(this.state.noveltyForDelete,this.getDeleteNoveltySuccess,this.getDeleteNoveltyError)
    this.setState({noveltyForDelete:false})
  }
  
  onDeleteNovelty(novelty){
    this.setState({noveltyForDelete:novelty})  
  }

  getDeleteNoveltySuccess(){
    this.props.actionGetNews(()=>{this.onChangePage(null,this.state.page)}, this.getNewsError)
  }

  getDeleteNoveltyError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar la novedad.")
  }
  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Imagen", "Título","Descripción", "Fecha", "Difusión"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let news = this.state.news
    // console.log("NEWS LIST", news, this.props.noveltyList)
    if(!news||news.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return news.map((item, index)=>{
       let isPublic=item.nvtDiffusion.toLowerCase() == "public"
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>
             {item.nvtImg?<img
								style={{ height: "85px", objectFit: "contain" }}
								src={item.nvtImg}
								alt=""
							/>:"Sin imagen"}
          </TableCell>
          <TableCell>{item.nvtTitle}</TableCell>
          <TableCell>{item.nvtDescription}</TableCell>
          <TableCell>{Util.formatDateToShow(Util.timestampToMoment(item.nvtDate))}</TableCell>
          <TableCell>{isPublic?"Pública":"Privada"}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Editar novedad">
              <IconButton onClick={this.onEditNovelty.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar novedad">
              <IconButton onClick={this.onDeleteNovelty.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, noveltyList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Novedades</Typography>
          <Typography variant="subtitle1">Crea novedades</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de novedades</Typography>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear novedad">
                <Fab color="primary" onClick={this.onAddNovelty} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input noveltyholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.noveltyForDelete}>
            <DialogTitle>Eliminar novedad</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar la novedad?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={()=>{this.setState({noveltyForDelete:null})}}>Cancelar</Button>
              <Button variant="contained" color="primary" onClick={this.onConfirmDeleteNovelty}>Eliminar</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    noveltyList: store.nvt.noveltyList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetNews,
      actionDeleteNovelty
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(News)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/News.js